import { TextField, TextFieldProps } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";

// ----------------------------------------------------------------------

interface IProps {
	name: string;
}

export default function RHFTextField({ name, ...other }: IProps & TextFieldProps) {
	const { control } = useFormContext();

	return (
		<Controller
			control={control}
			name={name}
			render={({ field, fieldState: { error } }) => (
				<TextField
					{...field}
					autoComplete='off'
					error={!!error}
					fullWidth
					{...other}
					onChange={(event) => {
						field.onChange(event);
						other.onChange?.(event);
					}}
					helperText={!!error ? error?.message : other.helperText}
				/>
			)}
		/>
	);
}
